function YearlyReport() {
  return <div>Banners</div>;
}

export default YearlyReport;
